import AddRoundedIcon from '@mui/icons-material/AddRounded'
import RemoveRoundedIcon from '@mui/icons-material/RemoveRounded'
import RestartAltRoundedIcon from '@mui/icons-material/RestartAltRounded'
import { createPortal } from 'react-dom'
import { useDashboardViewControlsSlot } from '../../context/dashboardViewControlsSlotCore'
import { IconButton } from '../Common/IconButton'

export const PannableCanvasControls = ({
  showZoom = true,
  onZoomIn,
  onZoomOut,
  onReset,
}: {
  showZoom?: boolean
  onZoomIn: () => void
  onZoomOut: () => void
  onReset: () => void
}) => {
  const controlsSlotEl = useDashboardViewControlsSlot()
  const controls = (
    <div className={`pannableCanvasControls${controlsSlotEl ? '' : ' pannableCanvasControls--inline'}`}>
      {showZoom && (
        <>
          <IconButton
            variant="tertiary"
            size="sm"
            onClick={onZoomIn}
            label="Zoom in canvas"
            icon={<AddRoundedIcon fontSize="small" />}
          />
          <IconButton
            variant="tertiary"
            size="sm"
            onClick={onZoomOut}
            label="Zoom out canvas"
            icon={<RemoveRoundedIcon fontSize="small" />}
          />
        </>
      )}
      <IconButton
        variant="tertiary"
        size="sm"
        onClick={onReset}
        label="Fit canvas to content"
        icon={<RestartAltRoundedIcon fontSize="small" />}
      />
    </div>
  )

  return controlsSlotEl ? createPortal(controls, controlsSlotEl) : controls
}
